import React, { useEffect, useState } from 'react';
import { TextareaAutosize } from '@material-ui/core';
import { Wrapper } from './FreeForm.Styles';
export var FreeForm = function (_a) {
    var values = _a.values, setFieldValue = _a.setFieldValue;
    var _b = useState('SQL Input'), filterSQL = _b[0], setFilterSQL = _b[1];
    useEffect(function () {
        setFilterSQL(values.filterSQL);
    }, [values.filterSQL]);
    var handleChange = function (event) {
        setFieldValue('filterSQL', event.target.value);
        setFilterSQL(event.target.value);
    };
    return (React.createElement(Wrapper, null,
        React.createElement(TextareaAutosize, { "aria-label": 'SQL Input', minRows: 3, maxRows: 10, value: filterSQL, onChange: handleChange, placeholder: 'SQL Input' })));
};
//# sourceMappingURL=FreeForm.js.map